module.exports = __webpack_public_path__ + "img/QTUM-alt.9a9c332d.svg";